import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {
	Link
} from 'react-router-dom';
import Loader from '../../components/Loader';
import axiosInstance from '../../utils/api';

type Props = {}

interface UsersInterface {
    customerid: string;
    // CUSTOMER INTERFACE
    location: string;
    name: string;

    // ACTUAL USERS INTERFACE
    // username: string;
    // password: string;
    // company: string;
    // fullname: string;
    // email: string;
    // phone: string;
}

const UsersList = (props: Props) => {
    const title = "Users"
    const [loading, setLoading] = useState(false)
    const [users, setUsers] = useState<Array<UsersInterface>>([])

    useEffect(() => {
        getUsersList()
    }, [])

    function getUsersList() {
        setLoading(true)
        axiosInstance.get("https://api.cl-ds.com/internal/operations/v1/customer").then(res => {
            setLoading(false)
            console.log(1, res.data)
            setUsers(res.data)
        }).catch(err => {
            setLoading(false)
            console.log(2, err)
        })
    }

    function handleDelete(id:string) {
        if (!window.confirm("Are you sure you want to delete record?")) return
        setLoading(true)
        axiosInstance.delete(`https://api.cl-ds.com/internal/operations/v1/customer/${id}/`).then(res=>{
            setLoading(false)
            console.log(11, res)
            alert(res.data.message)
            getUsersList()
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }

    return (
        <div className="col-12">
        {loading && ( <Loader/> )}

            <div className="card">
                <div className="card-body">
                    <div className="row px-2" style={{display:"grid", gridTemplateColumns:"1fr 1fr"}}>
                        <h5 className="card-title">{title} List</h5>
                        <div style={{display:"flex", justifyContent:"end", alignSelf:"center"}}>
                            <Link to="/users/add">
                                <button type="button" className="btn btn-outline-info">Create</button>
                            </Link>
                        </div>
                    </div>

                    <table className="table">
                        <thead>
                            <tr>
                                <th>Username</th>
                                {/* <th>Password</th> */}
                                <th>Full Name</th>
                                <th>Email</th>
                                <th>Company</th>
                                <th>Phone</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((user, index) => {
                                return (
                                    <tr key={index}>
                                        {/* FOR CUSTOMER INTERFACE */}
                                        <th>{user.name}</th>
                                        {/* <th>{user.location}</th> */}
                                        <td>John Doe</td>
                                        <td>johndoe@email.com</td>
                                        <td>cloudatik</td>
                                        <td>12345</td>
                                        <td>
                                            <Link to={`/users/edit/${user.customerid}`}>
                                                <button type="button" className="btn btn-outline-info"><i className="bi bi-pencil"></i></button>
                                            </Link>
                                            <button type="button" className="btn btn-outline-danger mx-1" onClick={()=>{handleDelete(user.customerid.toString())}}><i className="bi bi-trash"></i></button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default UsersList